

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID|| '',
    authority: process.env.REACT_APP_AUTHORITY || '',
    knownAuthorities: [process.env.REACT_APP_KNOWN_AUTHORITY || ''],
    redirectUri: process.env.REACT_APP_REDIRECT_URI|| '',
    postLogoutRedirectUri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI|| '',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: [
    "openid",
    "profile",
    "offline_access"
  ],
};

export const portalApiConfig = {
  host: process.env.REACT_APP_API_HOST,
  endpoints: {
    getClientName: "getclientname",
    getDatasetCatalogue: "getDatasetCatalogue",
    getDatasetDetail: "getdatasetdetail",
    createportaldatasetrequest: "createportaldatasetrequest",
    getdatasetrequeststatus: "getdatasetrequeststatus",
    downloaddataset: "downloaddataset",
    completedownload: "completedownload",
    downloadAttachment: "downloadattachment",
    cancelrequest: "cancelrequest",
  },
  subscriptionKey: process.env.REACT_APP_APIM_PORTAL_SUBSCRIPTION_KEY,
  trace: process.env.REACT_APP_APIM_PORTAL_TRACE,
};
